module.exports = __webpack_public_path__ + "img/IMG_8962.e8866242.jpg";